import React, { FC, useMemo } from 'react';

import { Container, Row } from 'layout';
import NewsGrid from 'common/NewsGrid';
import NewsList from 'common/NewsList';

import { useElasticContext } from '../../../contexts/elasticContext';
import { CustomHitsProps } from './models';

import './CustomHits.scss';

const CustomHits: FC<CustomHitsProps> = ({
  loadMoreText,
  isGridLayout,
  lang,
  hideLoadMoreButton,
  readingTimeText,
  writtenByText,
}) => {
  const { dataHits, loadMore, handleLoadMoreHits } = useElasticContext();

  const news = useMemo(
    () => (
      <div className="filters__hits">
        <Container>
          <div className="filters__hits-container">
            <Row className="filters__row-hits">
              {isGridLayout ? (
                <NewsGrid
                  sortedArticles={dataHits}
                  numberOfCol={3}
                  lang={lang}
                  readingTimeText={readingTimeText}
                  writtenByText={writtenByText}
                  hasTitle={false}
                />
              ) : (
                <NewsList articles={dataHits} lang={lang} readingTimeText={readingTimeText} />
              )}
            </Row>
            {!hideLoadMoreButton && loadMore ? (
              <button
                type="button"
                className="filters__hits-more-btn btn btn--primary btn--pink"
                onClick={handleLoadMoreHits}
                disabled={!loadMore}
              >
                {loadMoreText}
              </button>
            ) : null}
          </div>
        </Container>
      </div>
    ),
    [dataHits, isGridLayout, loadMore]
  );

  return news;
};
export default CustomHits;
